import Tr from '@/plugins/i18n/translations';
import {d} from '@/utils/consoleHelper.ts';

export default async () => {
    d.log('%c -- MIDDLEWARE -- LOCALE ✅', 'color: white; background: green; padding: 2px; font-weight: bold;');

    try {
        const guessedLocale = Tr.guessDefaultLocale() || Tr.defaultLocale;
        d.log('%c 🌍 Switching Locale:', 'color: cyan; font-weight: bold;', guessedLocale);

        await Tr.switchLanguage(guessedLocale);
    } catch (error) {
        d.error('%c ❌ Locale Middleware Error:', 'color: red; font-weight: bold;', error);
    }
}
